<template lang="pug">
v-card(:loading="busy" style="height:calc(100vh - 100px);")
  v-row.mx-1.my-0

    //- GRID
    v-col.pa-0.ma-0(
      :cols="(hasFilter && isFilterVisible) ? 9 : 12"
    )
      grid-ex-table(
        v-model="isFilterVisible"
        v-bind="$props"
        :set="set"
        :filter="filter"
        :selection="selection"
        @refresh="refresh"
        @select="value => select(value)"
        @perform="perform"
        @setAutoRefresh="value => $emit('setAutoRefresh', value)"
      )

    //- FILTER
    v-col.pa-0.ma-0.pl-0(cols="3" v-show="hasFilter && isFilterVisible")
      grid-ex-filter(
        v-model="isFilterVisible"
        v-bind="$props"
        :filter="filter"
        :selection="selection"
        @refresh="refresh"
        @select="value => select(value)"
        @perform="perform"
      )

  //- Diálogo de confirmação de operação
  action-dialog(
    v-bind="$props"
    :request="request"
    @actionComplete="actionComplete"
    @actionTerminate="request = null"
  )

</template>

<style>
  .x-btn-navbar {
    border: 1px solid #9995;
  }
</style>

<script>
import Vue from 'vue'

import GridExTable from './GridExTable'
import GridExFilter from './GridExFilter'
import ActionDialog from '@/components/commons/action-dialog/ActionDialog'

import { hasRel, hasNoRels } from "@/helpers/rels"
import { performAction } from '@/helpers/actions'
import { parseEref } from '@/helpers/erefs'

export default {
  components: {
    GridExTable,
    GridExFilter,
    ActionDialog,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    /**
     * Coleção de dicas de relacionamento.
     * Aplicável quando a rota é aberta por um link.
     * Esta propriedade carrega as dicas de relacionamento do link.
     */
    rel: Array,
    /**
     * Coleção de regras de abertura da rota.
     * Aplicável quando a rota é aberta por um link.
     */
    rule: Array,

    busy: Boolean,

    /**
     * Tempo de atualização automática da página.
     */
    autoRefresh: Number,
  },

  data: () => ({
    /**
     * Registros selecionados na grade.
     * @type {Array}
     */
    selection: [],

    /**
     * Registros selecionados na grade.
     * @type {Object}
     *    Format:
     *    {
     *      -- Link da requisição
     *      link: {Keep.Paper.Design.Link}
     *      -- Registros afetados pela requisição.
     *      selection: {Array}
     *    }
     */
    request: null, // Parâmetros de requisição
  }),

  computed: {
    dataSet() {
      return this.entity?.dataSet || {}
    },

    sets() {
      return this.dataSet.sets || []
    },

    set() {
      // Obtendo o primeiro dataset sem relacionamento definido. Este é considerado o dataset em si.
      const set = this.sets.find(set => hasNoRels(set))
      return set || {}
    },

    title: vm => vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    description: vm => vm.entity?.description,

    filter (vm) {
      let forms = vm.entity?.forms || []
      let filter = forms.filter(x => x.name === 'Filter')[0] || {}
      return filter;
    },
    fields: vm => vm.filter?.fields || [],
    hasFilter: vm => vm.fields.length > 0,

    isFilterVisible: {
      get () {
        return this.entity?.isFilterVisible !== undefined
          ? this.entity?.isFilterVisible : true
      },
      set (value) {
        this.$set(this.entity, 'isFilterVisible', value)
      }
    },

    // autoRefresh: vm => vm.entity?.autoRefresh || 0,
    // hasMoreData: vm => !!vm.set.hasMoreData,
    // hasSelection: vm => !!vm.selection.length,
    // hasActions: vm => !!vm.actions.length,
    // hasDataSetActions: vm => !!vm.dataSetActions.length,
  },

  methods: {
    actionComplete ({ success }) {
      if (success) {
        this.refresh()
        this.select([])
      }
    },

    select(selection) {
      this.selection = selection || []
    },

    isRowNonSelectable(row) {
      return row?.['@row']?.nonSelectable || hasRel(row?.['@row'], "Summary")
    },

    perform(opts) {
      const { selection } = opts
      const context = {
        site: this.site,
        eref: parseEref(this.eref),
        page: this.entity,
        data: this.entity?.dataSet?.sets?.[0] || null,
        // Se a seleção for um único registro então o usamos como linha afetada (row).
        row: Array.isArray(selection) ? null : selection
      }
      performAction(this, opts, context)
    },

    refresh () {
      const ok = this.$refs.form?.validate() || true
      if (!ok)
        return

      // Destacando os parâmetros da requisição...
      const form = {}
      this.fields.forEach(field => form[field.name] = field.value)

      this.$emit('refresh', { form, noCache: true, dataSetOnly: true })
    },

    isSearchField (field) {
      return field.rel?.includes('Search')
    },

    unwrapModel () {
      if (!this.blueprint || this.blueprint.set)
        return

      let fields = this.fields || []

      fields.forEach(field => {
        let hasValue = Object.prototype.hasOwnProperty.call(field, 'value')
        if (!hasValue) {
          Vue.set(field, "value", field.defaultValue || null);
        }
      })

      this.blueprint.set = true
    },
  },

  watch: {
    fields: "unwrapModel",
    $route () { this.select([]) },
  },

  mounted() {
    this.unwrapModel();
  },

  beforeDestroy() {
  },
}
</script>